import { LoginPayload, RequestOptions } from './../types/index';
import toast from "react-hot-toast";
import { RegisterPayload } from "../types";
import Cookies from "js-cookie";
import { AppDispatch } from "../store";
import { setUser } from '../features/auth/userSlice';
import i18n from '../i18n';
export const API_URL = 'https://libooking.com/api/';
export const API_SWEITCHER = "http://localhost:3001/";
export const IMAGE_MAIN_URL = "https://sehaty.azurewebsites.net/"
export const GOOGLE_CLIENT_ID = '799956672304-sjpo9s8grj6krbeq7vnoh5f6kbgp78tm.apps.googleusercontent.com'
//"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"
export const apiRequest = async (endpoint: string, options: RequestOptions = {}) => {
  try {
    const headers: Record<string, string> = {
      ...(options.headers as Record<string, string> || {}),
    };

    const isFormData = options.body instanceof FormData;

    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }
    headers["tz"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    headers["lang"] = i18n.language;
    if (options.auth) {
      const token = Cookies.get("accessToken"); 
      if (token) headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(`${API_URL}${endpoint}`, {
      method: options.method || 'GET',
      headers,
      body: options.body
        ? isFormData
          ? options.body
          : JSON.stringify(options.body)
        : undefined,
    });

    if (!response.ok) {
      const errorData = await safeParseJSON(response);
      const errorMessage =
        i18n.language === "ar"
          ? errorData?.message  || "حدث خطأ غير متوقع"
          : errorData?.message  || "An unexpected error occurred";

      toast.error(errorMessage);
      throw new Error(errorMessage);
    }

    return options.expectsBlob ? await response.blob() : await safeParseJSON(response);
  } catch (error: any) {
    throw error;
  }
};
const safeParseJSON = async (response: Response) => {
  try {
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  } catch (e) {
    console.warn('فشل في تحويل الاستجابة إلى JSON:', e);
    return null;
  }
};
//function for delete
export const deleteItem = async (
  endpoint: string,
  id: string | number,
  auth: boolean = true
) => {
  try {
    const response = await apiRequest(`${endpoint}${id}`, {
      method: 'DELETE',
      auth,
    });
    if (i18n.language === "ar") {
      toast.success(response.message)
    } else {
      toast.success(response.message)
    }
    return response
  } catch (error: any) {
    if (i18n.language === "ar") {
      toast.error(error.message || 'حدث خطأ أثناء التحديث')
    } else {
      toast.error(error.message || "unexpected error happen")
    }
  }
};
//function for delete item with  inner data
export const deleteElement = async (
  endpoint: string,
  Values: any,
  auth: boolean = true
) => {
  try {
    const response = await apiRequest(`${endpoint}`, {
      method: 'DELETE',
      body: Values,
      auth,
    });
    toast.success(response.message)
    return response;
  } catch (error) {
    console.error('Delete Error:', error);
    throw error;
  }
};

// handle auth
export const handleAuth = async (
  url: string,
  requestData: RegisterPayload | LoginPayload,
  navigate: any,
  dispatch: AppDispatch
) => {
  try {
    const response = await apiRequest(url, {
      method: 'POST',
      body: requestData
    });

    Cookies.set('accessToken', response.data.token, { expires: 7 });
    Cookies.set('userId', response.data.id, { expires: 7 });

    if (i18n.language === "ar") {
      toast.success(response.message)
    } else {
      toast.success(response.message)
    }
    dispatch(setUser(response.data));
    navigate("/")

    return response;
  } catch (error: any) {
    return null;
  }
};

export const handleLogout = () => {
  Cookies.remove('accessToken');
  Cookies.remove('userId');
  window.location.href = '/auth/login';
};


// Function to fetch data
export const fetchData = async (endpoint: string, auth: boolean = false, pagination?: boolean) => {
  try {
    const response = await apiRequest(endpoint, { auth });
    if (pagination) {
      return response
    }
    return response.data;
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
};

//Function to update item
export const handleUpdateItem = async (editValues: any, api: string, method: string) => {
  try {
    const response = await apiRequest(api, {
      method: method,
      body: editValues,
      auth: true
    });

    if (i18n.language === "ar") {
      toast.success(response.message)
    } else {
      toast.success(response.message)
    }
    return response
  } catch (error: any) {
    if (i18n.language === "ar") {
      toast.error(error.message || 'حدث خطأ أثناء التحديث')
    } else {
      toast.error(error.message || "unexpected error happen")
    }
  }
}
//Function to Add item
export const handleAddItem = async (Values: any, api: string, method: string) => {
  try {
    const response = await apiRequest(api, {
      method: method,
      body: Values,
      auth: true
    });
    if (i18n.language === "ar") {
      toast.success(response.message)
    } else {
      toast.success(response.message)
    }
    return response
  } catch (error: any) {
    if (i18n.language === "ar") {
      toast.error(error.message || 'حدث خطأ أثناء التحديث')
    } else {
      toast.error(error.message || "unexpected error happen")
    }
  }
};
export const handleFilter = async (Values: any, api: string, method: string) => {
  try {
    const response = await apiRequest(api, {
      method: method,
      body: Values,
      auth: true
    });

    return response;
  } catch (error: any) {
    toast.error(error.message || 'حدث خطأ أثناء التحديث');
  }
};

export const uploadImage = async (formData: FormData, endPoint: string) => {
  try {
    const token = Cookies.get("accessToken");

    const headers: HeadersInit = token ? { Authorization: `Bearer ${token}` } : {};

    const response = await fetch(`${API_URL}${endPoint}`, {
      method: 'POST',
      body: formData,
      headers,
    });
    /*  if (response.status === 401) {
          handleLogout();
          return null;
        } */
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || 'Image upload failed');
    }

    const data = await response.json();
    const resultText = data.filePath;
    return resultText;

  } catch (error: any) {
    console.error('Image upload error:', error);
    throw error;
  }
};


//Function to Get Data By Post method
export const handleGetDataByPost = async (Values: any, api: string, method: string) => {
  try {
    const response = await apiRequest(api, {
      method: method,
      body: Values,
      auth: true
    });

    return response
  } catch (error: any) {
    toast.error(error.message || 'حدث خطأ أثناء التحديث');
  }
};

// util function to detect card type
export const getCardType = (cardNumber: string) => {
  if (!cardNumber) return "Unknown";
  const num = cardNumber.replace(/\s+/g, ""); // remove spaces
  if (/^4/.test(num)) return "Visa";
  if (/^(5[1-5]|2[2-7])/.test(num)) return "MasterCard";
  if (/^3[47]/.test(num)) return "American Express";
  return "Unknown";
};


// colors of booking status
export const getStatusClass = (status: string | undefined) => {
  if (status === 'Approved' || status === 'Paid') return 'text-primary'
  if (status === 'Pending' || status === 'Returned' || status === 'Waiting') return 'text-secondry'
  return 'text-red-600'
}

// format fate
export const formatDateRange = (
  checkIn: string,
  checkOut: string,
  showTime?: boolean
) => {
  const locale = i18n.language === 'ar' ? 'ar-EG' : 'en-US'
  const start = new Date(checkIn)
  const end = new Date(checkOut)

  const startMonth = start.toLocaleDateString(locale, { month: 'long' })
  const endMonth = end.toLocaleDateString(locale, { month: 'long' })

  const startYear = start.getFullYear()
  const endYear = end.getFullYear()

  let dateStr = ''

  if (startMonth === endMonth && startYear === endYear) {
    dateStr = `${start.getDate()}-${end.getDate()} ${endMonth} ${endYear}`
  } else {
    const startStr = `${start.getDate()} ${startMonth} ${startYear}`
    const endStr = `${end.getDate()} ${endMonth} ${endYear}`
    dateStr = `${startStr} - ${endStr}`
  }


  if (showTime) {
    const timeOptions: Intl.DateTimeFormatOptions = {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    }

    const startTime = start.toLocaleTimeString(locale, timeOptions)
    const endTime = end.toLocaleTimeString(locale, timeOptions)

    dateStr += ` (${i18n.language === 'ar' ? 'من' : 'from'} ${startTime} ${
      i18n.language === 'ar' ? 'إلى' : 'to'
    } ${endTime})`
  }

  return dateStr
}


// ✅ cancelBook
export const canCancel = (checkIn: string) => {
  const now = new Date()
  const checkInDate = new Date(checkIn)
  const diff = checkInDate.getTime() - now.getTime()
  return diff > 24 * 60 * 60 * 1000
}

export const downloadReport = async (
  endpoint: string,
  body: any,
  fileName: string,
  method: string = "POST"
) => {
  try {
    const blob = await apiRequest(endpoint, {
      method,
      body,
      auth: true,
      expectsBlob: true,
    });

    if (!blob) throw new Error("Report download failed");

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    console.error("Download report error:", error);
  }
};